import React, { useEffect, useState } from 'react';
// import SystemDashboard from 'layouts/SystemDashboard';
import {
  deleteMembership,
  getAllMembershipsByAccountId,
} from './MembershipService';

// import { getSection } from '../Sections/SectionService';
import {
  Button,
  Typography,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Box,
} from '@mui/material';
import { useNavigate, useParams } from 'react-router-dom';
// import { alpha, useTheme } from '@mui/material/styles';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import IconButton from '@mui/material/IconButton';
import DeleteIcon from '@mui/icons-material/Delete';
import ListItem from '@mui/material/ListItem';
import ListItemText from '@mui/material/ListItemText';
import Container from 'components/Container';
import { notify } from 'utils/notify';
import { extractErrorMessage } from 'utils/extractErrorMessage';

const MembershipList = (): JSX.Element => {
  const [memberships, setMemberships] = useState<any[]>([]);
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const [openDialog, setOpenDialog] = useState(false);
  const [membershipIdToDelete, setMembershipIdToDelete] = useState(null);

  const { accountid } = useParams();
  // const { membershipid } = useParams()

  useEffect(() => {
    listMemberships();
  }, []);

  function listMemberships() {
    setLoading(true); // Set loading to true when starting the request
    getAllMembershipsByAccountId(accountid)
      .then((response) => {
        setMemberships(response.data);
      })
      .catch((error) => {
        console.error(error);
        notify(extractErrorMessage(error));
      })
      .finally(() => {
        setLoading(false); // Set loading to false when the request is completed (whether successful or not)
      });
  }

  function addMembership() {
    navigate(`/system/dashboard/account/${accountid}/add-membership`);
  }

  function selectMembership(membershipid) {
    console.log(membershipid);
    navigate(
      `/system/dashboard/account/${accountid}/membership/${membershipid}`,
    );
  }

  const handleDeleteConfirmation = (membershipId) => {
    setMembershipIdToDelete(membershipId);
    setOpenDialog(true);
  };

  const handleDeleteItem = () => {
    // Call your removeItem function to delete the item
    removeMembership(membershipIdToDelete);
    // Close the dialog
    setOpenDialog(false);
  };

  function removeMembership(membership) {
    deleteMembership(membership)
      .then(() => {
        listMemberships();
      })
      .catch((error) => {
        // Handle errors or exceptions
        if (error.response) {
          // The request was made and the server responded with a status code
          // Display an error message based on the response status
          console.error(
            'Request failed with status code:',
            error.response.status,
          );
          // Check if the error is due to a foreign key constraint violation
          if (
            error.response.status === 400 &&
            typeof error.response.data === 'string' &&
            error.response.data.includes('foreign key constraint')
          ) {
            // Display a user-friendly error message informing the user that they can't delete the item
            notify(
              'Cannot delete the item because it is referenced by other records.',
            );
          }
          if (error.response.status === 401) {
            // Display a user-friendly error message informing the user that they can't delete the item
            notify(
              'Cannot delete or update a parent row: a foreign key constraint fails.',
            );
          } else {
            // Display a generic error message for other types of errors
            notify(
              'An error occurred while deleting the item. Please try again later.',
            );
          }
        } else if (error.request) {
          // The request was made but no response was received
          console.error(
            'Request made but no response received:',
            error.request,
          );
        } else {
          // Something happened in setting up the request that triggered an error
          console.error('Error setting up the request:', error.message);
        }
      });
  }

  return (
    <Container>
      {/* <SystemDashboard>
        <Box marginTop={2} marginBottom={4}>
          <Breadcrumbs aria-label="breadcrumb">
            <Link underline="hover" color="inherit" href="/">
              System Content
            </Link>
            <Link
              underline="hover"
              color="inherit"
              href={'/system/dashboard/accounts'}
            >
              Accounts
            </Link>
            <Link
              underline="hover"
              color="inherit"
              href={'/system/dashboard/accounts'}
            >
              Account Detail
            </Link>
            <Typography color="text.primary">List of memberships</Typography>
          </Breadcrumbs>
        </Box>
        
      </SystemDashboard> */}
      <Box
        display="flex"
        justifyContent="space-between"
        alignItems="center"
        marginBottom={4}
      >
        <Typography variant="h4">List of Memberships</Typography>
        <Button variant="contained" onClick={addMembership}>
          Add Membership
        </Button>
      </Box>
      {loading && <p>Loading...</p>}
      <TableContainer component={Paper}>
        <Table sx={{ minWidth: 750 }} aria-label="simple table">
          <TableHead sx={{ bgcolor: 'alternate.main' }}>
            <TableRow>
              <TableCell>
                <Typography
                  color={'text.secondary'}
                  variant={'caption'}
                  fontWeight={700}
                  sx={{ textTransform: 'uppercase' }}
                >
                  ID
                </Typography>
              </TableCell>
              <TableCell>
                <Typography
                  color={'text.secondary'}
                  variant={'caption'}
                  fontWeight={700}
                  sx={{ textTransform: 'uppercase' }}
                >
                  Membership Name
                </Typography>
              </TableCell>
              <TableCell>
                <Typography
                  color={'text.secondary'}
                  variant={'caption'}
                  fontWeight={700}
                  sx={{ textTransform: 'uppercase' }}
                >
                  Status
                </Typography>
              </TableCell>
              <TableCell />
              <TableCell />
            </TableRow>
          </TableHead>
          <TableBody>
            <Dialog open={openDialog} onClose={() => setOpenDialog(false)}>
              <DialogTitle>Confirm Deletion</DialogTitle>
              <DialogContent>
                Are you sure you want to delete this membership?
              </DialogContent>
              <DialogActions>
                <Button onClick={() => setOpenDialog(false)}>Cancel</Button>
                <Button onClick={handleDeleteItem} autoFocus>
                  Delete
                </Button>
              </DialogActions>
            </Dialog>
            {memberships
              .sort((a, b) => a.id - b.id)
              .map((item, i) => (
                <TableRow
                  key={i}
                  sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                  onClick={() => selectMembership(item.id)}
                >
                  <TableCell component="th" scope="row">
                    <ListItem sx={{ p: 0, m: 0 }}>
                      <ListItemText primary={item.id} secondary={item.id} />
                    </ListItem>
                  </TableCell>
                  <TableCell>
                    <Typography color={'text.secondary'} variant={'subtitle2'}>
                      {item.membershipName}
                    </Typography>
                  </TableCell>
                  <TableCell>
                    <Typography color={'text.secondary'} variant={'subtitle2'}>
                      {item.status}
                    </Typography>
                  </TableCell>
                  <TableCell>
                    <Typography
                      color={'primary'}
                      variant={'subtitle2'}
                      fontWeight={700}
                      sx={{ cursor: 'pointer' }}
                    >
                      Edit
                    </Typography>
                  </TableCell>
                  <TableCell>
                    <Typography
                      color={'primary'}
                      variant={'subtitle2'}
                      fontWeight={700}
                      sx={{ cursor: 'pointer' }}
                    >
                      <IconButton
                        onClick={(event) => {
                          event.stopPropagation(); // Stop the click event from propagating
                          handleDeleteConfirmation(item.id); // Show confirmation dialog before deleting
                        }}
                      >
                        <DeleteIcon />
                      </IconButton>
                    </Typography>
                  </TableCell>
                </TableRow>
              ))}
          </TableBody>
        </Table>
      </TableContainer>
    </Container>
  );
};

export default MembershipList;
